export default __webpack_public_path__ + "static/media/0x42e5e06ef5b90fe15f853f59299fc96259209c5c.4f4f5bb9.webp";